<script lang="ts">
    import {  defineComponent } from "vue";
    

    export default defineComponent({
        components: {  },
        data() {
            return {
                showImage: true,
                videoUrl: "https://www.youtube.com/embed/kM6yarkMYr8?si=b8-0nC3xH0j-7yEn",
                videoThumbnail: "../pagesImages/play-icon.png",   
            };
        },
        methods: {
            showVideo() {
                this.showImage = false;
            },
            
        },
    });
</script>

<template>
    <section class="flex justify-center items-center w-full h-full bg-cover lg:h-[500px] md:bg-center bg-[left] bg-no-repeat" style="background-image: url(/pagesImages/portada-una-persona-humanitas-BLANCO.webp);">
        <div class="lg:flex justify-between w-full max-w-4xl lg:max-w-[1200px] items-center">
            <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[40%] w-full lg:my-24 my-12 text-justify px-4">
                <h2 class="text-hwine text-left leading-tight">
                    <span class="text-[28px]">Ser una persona en</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block font-serif text-[46px] mb-2">Humanitas</span>
                </h2>
                <p class="text-gray-800 text-base">
                    Dignidad humana significa que un individuo siente respeto por s&iacute; mismo y se valora al mismo tiempo que es respetado y valorado. Implica la necesidad de que todos los seres humanos sean tratados en un pie de igualdad y que puedan gozar de los derechos fundamentales que de ellos derivan.
                </p>
                <br>
                <router-link to="/contacto" class="">
                    <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white text-lg transition duration-300 ease-in-out">
                        <span>Inscr&iacute;bete</span>
                    </div>
                </router-link>
            </div>
            <div class="flex flex-col items-center justify-center lg:w-[30%] w-full my-16 ">
                <div class="flex justify-center w-full h-full items-center ">
                    <VideoHiL :thumbnailUrl="videoThumbnail" :videoUrl="videoUrl" class="w-[100%] md:px-16 lg:px-0"/>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
</style>